export default __webpack_public_path__ + "static/3-aa10810e173296e520e9393be7d4aaf6.webp";